import { _ } from '../utils'

export default function ImageUpload(el) {
    const input = el.querySelector(_('input', 'element').str())
    const image = el.querySelector(_('image', 'element').str())
    const error = document.querySelector(
        _('image-upload-error', 'element').str()
    )

    input.addEventListener('change', () => {
        const file = input.files[0]
        const reader = new FileReader()

        if (/image\/(jpe?g|png|gif)/g.test(file.type)) {
            const sizeInKB = file.size / 1000
            if (sizeInKB < 2000) {
                reader.addEventListener(
                    'load',
                    () => {
                        image.src = reader.result
                        image.style.display = 'block'
                    },
                    false
                )

                error.classList.add('u-hidden')
                if (file) {
                    reader.readAsDataURL(file)
                }
            } else {
                error.innerHTML = 'Sorry, your image must be under 2MB in size.'
                error.classList.remove('u-hidden')
            }
        } else {
            error.innerHTML = 'Sorry, your image must of type JPEG, PNG or GIF.'
            error.classList.remove('u-hidden')
        }
    })
}
